import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const TableLimit = ({ store }) => {
    const changeValue = (event) => {
        store.limit = event.target.value;
    };
    return (
        <div>
            <select className="form-control mb-2 mr-sm-2 mb-sm-0" value={store.limit} onChange={changeValue}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>
        </div>);
};


TableLimit.propTypes = {
    store: PropTypes.object.isRequired,
};

export default (observer(TableLimit));
